import AWS from 'aws-sdk'
import { useCallback, useReducer, useMemo } from 'react'
import { reducerMerger } from 'utils/hook'
import { mean, has, isEmpty, get } from 'lodash'
import { exportFile } from 'utils/convert'
const songBucketName = 'knightranger-input'
const videoBucketName = 'knightranger-video-upload'
const bucketRegion = 'us-east-1'
const IdentityPoolId = 'us-east-1:ff798f30-95e8-41f6-b84b-7ed2dc7f70c3'

AWS.config.update({
  region: bucketRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: IdentityPoolId,
  }),
})

const parseName = (text) => text.replace(/[^a-zA-Z0-9/.]/g, '')
export const useKaraokeUpload = () => {
  const [state, setState] = useReducer(reducerMerger, {
    progressAudio: 0,
    progressVideo: 0,
    finished: false,
  })

  const startUpload = useCallback(
    async ({ audio, lyrics, instructions, metadata }) => {
      if (!has(audio, 'name') || isEmpty(instructions) || isEmpty(lyrics))
        return

      const { hasVocals } = metadata
      const Email = get(metadata, 'email', 'none')
      const Title = get(metadata, 'title', 'none')
      const Artist = get(metadata, 'artist', 'none')
      const Album = get(metadata, 'album', 'none')
      const SpotifyId = get(metadata, 'spotifyId', 'none')
      const HasVocals = `${hasVocals}`

      const name = `${parseName(Title)}-${parseName(Artist)}`
      const songFormat = audio.name.split('.').pop()
      const songName = `${name}.${songFormat}`
      const instructionsName = `${name}.json`
      const Metadata = {
        Email,
        Title,
        Artist,
        Album,
        SpotifyId,
        HasVocals,
      }

      // const folderName = encodeURIComponent(name) + '/'
      // Use S3 ManagedUpload class as it supports multipart uploads
      const audioUpload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: songBucketName,
          Key: songName,
          Metadata,
          Body: audio.blob,
          ACL: 'public-read',
        },
      })
      const instructionsBlob = exportFile({
        lyrics,
        instructions,
      })
      const instructionsUpload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: videoBucketName,
          Key: instructionsName,
          Metadata,
          Body: instructionsBlob,
        },
      })
      audioUpload.on('httpUploadProgress', function (progress) {
        const progressAudio = (progress.loaded / progress.total) * 100
        setState({ progressAudio })
      })

      instructionsUpload.on('httpUploadProgress', function (progress) {
        const progressVideo = (progress.loaded / progress.total) * 100
        setState({ progressVideo })
      })

      try {
        await Promise.all([audioUpload.promise(), instructionsUpload.promise()])
        setState({ finished: true })
        // All finished
        console.log(
          'Successfully uploaded video. Now we need to upload the song'
        )
      } catch (error) {
        console.error(error)
        alert('Error uploading song: ', error.name)
      }
    },
    []
  )

  const progress = useMemo(
    () => mean([state.progressAudio, state.progressVideo]),
    [state]
  )

  return {
    ...state,
    startUpload,
    progress,
  }
}
